/**************************************************
 * Nombre:       Home_Capacitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import {useState} from "react";
import {where} from "firebase/firestore";
import useRecuperarColleccionListeningProg from "../../../Servicios/BD/useRecuperarColleccionListeningProg";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Testimonio from "../../Dialogos/Dialogo_Testimonio";

const Testimonios_Portada = () => {
    const [wheres, setWheres] = useState([where('estado', '==', 'Publicado')]);
    const {data, cargarMas} = useRecuperarColleccionListeningProg({col: 'testimonios', wheres: wheres});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Testimonio,
        titulo: 'Sube tu testimonio'
    })

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                overflowX: 'hidden',
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{color: '#262626', fontSize: 40, fontWeight: 700}}>
                                        Testimonios
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 6}}
                                      sx={{justifyContent: 'flex-end', mt: 0}}>
                                    <Typography
                                        sx={{color: '#545454', fontSize: 16, fontWeight: 400, textAlign: 'right'}}>
                                        Las personas están probando y comprobando con los resultados de nuestros
                                        productos, estamos cambiando vidas
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Button
                                        onClick={() => abrir()}
                                        variant={'outlined'} sx={{px: 6}}>Compartenos el tuyo</Button>
                                </Grid>


                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 8}}>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={6}
                            >

                                {data.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Testimonio item={it}/>
                                    </Grid>
                                ))}

                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Button onClick={() => cargarMas()} variant={'outlined'}>Cargar Mas</Button>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Testimonios_Portada
